import previewView from './previewView.js';
import View from './View.js';

class BookmarksView extends View {
  _errorMessage = `No bookmarks yet. Find a nice recipe and bookmark it...`;

  addHandlerRender(handler) {
    addEventListener('load', handler);
  }

  _generateMarkup() {
    return this._data
      .map(bookmark => previewView.render(bookmark, false))
      .join('');
  }
}

export default new BookmarksView('.bookmarks__list');
